import { Link, NavLink } from "react-router-dom";
import { Clock3, Instagram, MessageCircle, Phone } from "lucide-react";
import { FACEBOOK, INSTAGRAM,TIKTOK, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK } from "../lib/constants";
import { useAppointment } from "../context/AppointmentContext";
import CERTIFICATE_URL from "../assets/carti.svg";
import FacebookIcon from "../assets/facebook.svg";
import TikTokIcon from "../assets/header_tiktok.svg";
import logo from "../assets/headerlogo.png";
import whatsapp from "../assets/whatsapplogo.svg";

export default function Navbar() {
  const { openAppointment } = useAppointment();

  return (
    <header className="fixed inset-x-0 top-0 z-50 hidden bg-white shadow-[0_1px_0_rgba(10,31,102,0.08)] [--site-edge:24px] lg:block lg:[--site-edge:40px] xl:[--site-edge:64px] min-[1600px]:[--site-edge:96px] min-[1800px]:[--site-edge:130px]" data-testid="site-navbar">
      <div className="bg-[#06386f] text-white">
        <div className="flex h-[64px] w-full items-center justify-between gap-5 px-[var(--site-edge)] text-[12px] font-semibold lg:text-[13px] xl:text-[14px]">
          <div className="flex min-w-0 items-center gap-1 text-[13px] lg:text-[14px] xl:text-[16px]">
            <img src={CERTIFICATE_URL} alt="Certificate" className="h-6 w-6" />
            <span className="truncate">10+ YEARS OF CLINICAL EXCELLENCE IN JAMAICA</span>
          </div>
          <div className="flex shrink-0 items-center gap-3 xl:gap-4">
            <a href={`tel:${PHONE_TEL}`} className="inline-flex items-center gap-2 whitespace-nowrap">
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
            <span className="h-4 w-px bg-white/55" />
            <span className="inline-flex items-center gap-2 whitespace-nowrap">
              <Clock3 className="h-4 w-4" />
              Mon-Fri 9AM-5PM | Every other Sat 9AM-12PM
            </span>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" aria-label="Instagram">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={FACEBOOK} target="_blank" rel="noreferrer" aria-label="Facebook">
              <img src={FacebookIcon} alt="Facebook" className="h-4 w-4" />
            </a>
            <a href={TIKTOK} target="_blank" rel="noreferrer" aria-label="TikTok">
              <img src={TikTokIcon} alt="TikTok" className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="flex h-[92px] w-full items-center justify-between gap-4 px-[var(--site-edge)]">
        <Link to="/" className="flex min-w-[248px] shrink-0 items-center gap-3 xl:min-w-[300px] min-[1600px]:min-w-[360px] min-[1800px]:min-w-[430px]" data-testid="nav-logo-link">
          <img src={logo} alt="Be Dental Paradise" className="h-[60px] w-[60px] shrink-0 rounded-[16px] object-cover shadow-[0_4px_12px_rgba(0,82,255,0.12)] min-[1600px]:h-[65px] min-[1600px]:w-[65px] min-[1800px]:h-[70px] min-[1800px]:w-[70px]" />
          <div className="flex min-w-0 flex-col justify-center leading-none">
            <div className="whitespace-nowrap text-[24px] font-semibold text-[#071746] lg:text-[23px] xl:text-[26px] min-[1600px]:text-[34px] min-[1800px]:text-[42px]">Be Dental Paradise</div>
            <div className="mt-1 whitespace-nowrap text-[12px] font-semibold uppercase text-[#0052ff] lg:text-[11px] xl:text-[12px] min-[1600px]:text-[17px] min-[1800px]:text-[22px]">Beautiful smiles. Created here</div>
          </div>
        </Link>

        <nav className="flex min-w-0 shrink items-center justify-center gap-3 lg:gap-3 xl:gap-6 min-[1600px]:gap-8 min-[1800px]:gap-10">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `relative whitespace-nowrap py-2 text-[13px] font-bold text-black transition-colors hover:text-[#0052ff] lg:text-[14px] xl:text-[14px] min-[1600px]:text-[15px] min-[1800px]:text-[17px] ${
                  isActive ? "text-[#0052ff] after:absolute after:inset-x-0 after:-bottom-1 after:h-[3px] after:bg-[#0052ff]" : ""
                }`
              }
              data-testid={`nav-link-${link.label.toLowerCase()}`}
            >
              {link.label === "Services" ? "Service" : link.label}
            </NavLink>
          ))}
          <button
            type="button"
            onClick={openAppointment}
            className="relative whitespace-nowrap py-2 text-[13px] font-bold text-black transition-colors hover:text-[#0052ff] lg:text-[14px] xl:text-[14px] min-[1600px]:text-[15px] min-[1800px]:text-[17px]"
            data-testid="nav-book-appointment"
          >
            Book Appointment
          </button>
        </nav>

        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-flex h-[56px] shrink-0 items-center justify-center gap-2 rounded-[14px] bg-[#079b65] px-3 text-[13px] font-bold leading-none text-white transition hover:bg-[#078759] lg:min-w-[168px] xl:min-w-[180px] xl:px-4 xl:text-[14px] min-[1600px]:min-w-[230px] min-[1600px]:gap-3 min-[1600px]:px-5 min-[1600px]:text-[16px] min-[1800px]:w-[277px] min-[1800px]:px-6 min-[1800px]:text-[18px]"
          data-testid="nav-whatsapp-btn"
        >
          <img src={whatsapp} alt="WhatsApp" className="h-5 w-5 shrink-0 xl:h-6 xl:w-6 min-[1600px]:h-[26px] min-[1600px]:w-[26px] min-[1800px]:h-7 min-[1800px]:w-7" />
          <span className="whitespace-nowrap">Book on WhatsApp</span>
        </a>
      </div>
    </header>
  );
}
